"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceptionExtensionDefinition = void 0;
const WidgetExtensionPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPlugin");
const WidgetExtensionPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPluginDefinition");
const InchcapeInternalEvents_1 = require("../../../../Enum/InchcapeInternalEvents");
class ExceptionExtension extends WidgetExtensionPlugin_1.default {
    /**
     * @inheritDoc
     */
    initialize(widget) {
        this.widget = widget;
        this.widget.getEventContainer()
            .on(InchcapeInternalEvents_1.InchcapeInternalEvents.SET_STEP, (step) => {
            this.widget.setStep(step);
        });
        return Promise.resolve();
    }
}
exports.default = ExceptionExtension;
exports.ExceptionExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    id: "exception",
    class: ExceptionExtension
});
